import api from "../axios-client";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useUploadPackage = () => {
    return useMutation({
        mutationFn: (formData) =>
            api.post("/api/update/create-package", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }),
    });
};

// Additional hook for fetching available packages
export const useAvailablePackages = () => {
    return useQuery({
        queryKey: ['availablePackages'],
        queryFn: () => api.get("/api/update/available-packages"),
    });
};

// Hook to get the latest version
export const useLatestVersion = () => {
    return useQuery({
        queryKey: ['latestVersion'],
        queryFn: async () => {
            const response = await api.get("/api/update/version", {
                transformResponse: [(data) => data], // Prevent JSON parsing
                responseType: 'text'
            });
            return response.data;
        },
    });
};